import { preload } from './modules/preload'
import { nav } from './modules/nav'
import { slider } from './modules/slider'
import { facts } from './modules/facts'
import { toggleItem } from './modules/toggleItem'
import { counter } from './modules/counter'
import { lightbox } from './modules/lightbox'
import { openFilter } from './modules/openFilter'
import { onScroll } from './modules/onScroll'
import { dialog } from './modules/dialog'
import { bannerForms } from './modules/bannerForms'
import { accessibility } from './modules/accessibility'
import { iframeHeightCalc } from './modules/iframeHeightCalc'
import { devicecheck } from './modules/devicecheck'
import { videoPlayer } from './modules/videoPlayer'
// import { cursor } from './modules/cursor'

import './modules/animations.js'

window.onload = function () {
	slider()
	onScroll()
	preload()
	nav()
	openFilter()
	lightbox()
	counter()
	dialog()
	toggleItem()
	facts()
	bannerForms()
	accessibility()
	iframeHeightCalc()
	devicecheck()
	videoPlayer()
	// cursor()

	const swiper2 = new Swiper('.ref-swiper-target', {
		// Disable all user interaction
		allowTouchMove: false,
		simulateTouch: false,
		// Ensure it matches the loop behavior of the first one
		loop: true,
		// Center the active slide
		centeredSlides: true,
		slidesPerView: 1, // Forces only one slide to be "active" at a time
	})

	const swiper = new Swiper('.ref-swiper', {
		// pass EffectCarousel module to modules
		modules: [EffectCarousel],
		// specify "carousel" effect
		effect: 'carousel',
		// carousel effect parameters
		carouselEffect: {
			// opacity change per side slide
			opacityStep: 0.33,
			// scale change per side slide
			scaleStep: 0.2,
			// amount of side slides visible, can be 1, 2 or 3
			sideSlides: 2,
		},
		// navigation arrows
		navigation: {
			nextEl: '.ref-swiper-button-next',
			prevEl: '.ref-swiper-button-prev',
		},
		grabCursor: true,
		loop: true,
		loopAdditionalSlides: 1,
		slidesPerView: 'auto',
	})

	// Sync via realIndex to avoid clone-count mismatch between the two loop swipers
	swiper.on('slideChange', function () {
		swiper2.slideToLoop(swiper.realIndex)
	})

	const swiper3 = new Swiper('.location-swiper-target', {
		// Disable all user interaction
		allowTouchMove: false,
		simulateTouch: false,
		// Ensure it matches the loop behavior of the first one
		loop: true,
		// Center the active slide
		centeredSlides: true,
		slidesPerView: 1, // Forces only one slide to be "active" at a time
	})

	const locationswiper = new Swiper('.location-swiper', {
		// pass EffectCarousel module to modules
		modules: [EffectCarousel],
		// specify "carousel" effect
		effect: 'carousel',
		// carousel effect parameters
		carouselEffect: {
			// opacity change per side slide
			opacityStep: 0.33,
			// scale change per side slide
			scaleStep: 0.2,
			// amount of side slides visible, can be 1, 2 or 3
			sideSlides: 1,
		},
		// navigation arrows
		navigation: {
			nextEl: '.location-swiper-button-next',
			prevEl: '.location-swiper-button-prev',
		},
		grabCursor: true,
		loop: true,
		loopAdditionalSlides: 1,
		slidesPerView: 'auto',
	})

	// Sync via realIndex to avoid clone-count mismatch between the two loop swipers
	locationswiper.on('slideChange', function () {
		swiper3.slideToLoop(locationswiper.realIndex)
	})
}

$(document).ready(function () {
	$('.news-slider').slick({
		speed: 500,
		fade: true,
		cssEase: 'linear',
		arrows: true,
		dots: false,
		draggable: false,
		waitForAnimate: false,
	})

	// Handle clickable news images
	$('.clickable-news-image').on('click', function () {
		const slideIndex = parseInt($(this).attr('data-news-id'))

		// Navigate slider to corresponding slide
		$('.news-slider').slick('slickGoTo', slideIndex)

		// Update active states
		$('.clickable-news-image').removeClass('active')
		$(this).addClass('active')
	})

	// Sync active image when slider changes
	$('.news-slider').on('afterChange', function (event, slick, currentSlide) {
		$('.clickable-news-image').removeClass('active')
		$(`.clickable-news-image[data-news-id="${currentSlide}"]`).addClass('active')
	})

	// Set initial active state
	$('.clickable-news-image').first().addClass('active')
})
